import React, {useEffect, useState} from "react";
import { useIntl } from 'react-intl';

// Components
import { Form, ToggleSwitch, Pill } from 'Components';
import { Grid } from '@mui/material';
import Slider from 'Components/Slider';
import TriggerLandmark from "Modules/alerts/components/wizardAlert/common/components/TriggerLandmark";


export const Idle = (props) => {

    const { value, onChange, formRef, triggers, triggersRaw } = props
    const { messages } = useIntl()
    const [showErrorTrigger, setShowErrorTrigger] = useState(false)

    useEffect(() => {
        if (value.triggerDuration == undefined)
            onChange({
                ...value,
                triggerDuration: {
                    duration: 'Hours',
                    value: 1
                },
                allowIdlingWhenPTOOn: false,
            })
    }, [value])

    return (
        <Form ref={formRef}
              onSubmit={() => {
                  if (value.trigger) {
                      let isValid = triggersRaw?.length > 0

                      if (!isValid) {
                          setShowErrorTrigger(true)
                      } else setShowErrorTrigger(false)
                      return isValid
                  }
              }}
        >
            {
                value.triggerDuration != undefined &&
                <Grid container justifyContent={'center'} direction={'column'} style={{ paddingTop: 10 }}>
                    <Grid item >
                        <div style={{ paddingBottom: 5 }}>
                            <label className="input-normal-label" >{messages['alertsNewAlert_triggersLabel']}</label>
                        </div>
                        <Grid container direction="row" alignItems={'center'} spacing={1} color="primary" aria-label="outlined primary button group">
                            <Grid item sm={6}>
                                <Pill
                                    textField={'name'}
                                    item={{ id: "Minutes", name: messages["alertsNewAlert_minutesLabel"] }}
                                    outlined={value.triggerDuration?.duration !== "Minutes"}
                                    onClick={(entity) => {
                                        onChange({ ...value, triggerDuration: { value: 5, duration: "Minutes" } })
                                    }}
                                    style={{ border: '0', margin: '2px 0', width: '100%' }}
                                    label="pill-label-text"
                                    colorField="default"
                                    colorSelection="005bf8"
                                />
                            </Grid>
                            <Grid item sm={6}>
                                <Pill
                                    textField={'name'}
                                    item={{ id: "Hours", name: messages["alertsNewAlert_hoursLabel"] }}
                                    outlined={value.triggerDuration?.duration !== "Hours"}
                                    onClick={(entity) => {
                                        onChange({ ...value, triggerDuration: { value: 1, duration: "Hours" } })
                                    }}
                                    style={{ border: '0', margin: '2px 0', width: '100%' }}
                                    label="pill-label-text"
                                    colorField="default"
                                    colorSelection="005bf8"
                                />
                            </Grid>
                        </Grid>

                        <div style={{ width: '100%', paddingTop: 10 }}>
                            <label className="input-normal-label">{value.triggerDuration?.duration === "Minutes" ? messages['alertsNewAlert_minutesLabel'] : messages['alertsNewAlert_hoursLabel']}</label>
                            <Slider
                                min={value.triggerDuration?.duration === "Minutes" ? 5 : 1}
                                max={value.triggerDuration?.duration === "Minutes" ? 59 : 24}
                                value={value.triggerDuration?.value}
                                onChange={(event) => {
                                    onChange({ ...value, triggerDuration: { ...value.triggerDuration, value: event } })
                                }}
                                sliderOneColor={false}
                                showValue
                                valueLabelDisplay={'off'}
                            />
                        </div>

                        <div style={{ paddingTop: "20px", width: "100%" }}>
                            <ToggleSwitch
                                id="allowIdlingWhenPTOOn"
                                small
                                blueToggle
                                optionLabels={["", ""]}
                                label={messages['alertsNewAlert_allowIdlingWhenPTO']}
                                checked={value.allowIdlingWhenPTOOn}
                                onChange={(event) => onChange({ ...value, allowIdlingWhenPTOOn: event })}
                            />
                        </div>
                        <TriggerLandmark config={value} triggers={triggers} triggersRaw={triggersRaw} onChange={onChange} showErrorTrigger={showErrorTrigger}/>
                    </Grid>
                </Grid>
            }
        </Form>
    );
}
